import Styled from 'styled-components'

const Form = Styled.form.attrs({
  className: 'react-og-form'
})`

`
export default Form
